import * as _ from 'lodash';
import { QuickQuoteService } from './quick-quote.service';
import { QUICK_QUOTE_CONSTANTS } from '../quick-quote.constants';
import * as i0 from "@angular/core";
import * as i1 from "./quick-quote.service";
var GrayoutService = /** @class */ (function () {
    function GrayoutService(quickQuoteService) {
        this.quickQuoteService = quickQuoteService;
        this.constants = QUICK_QUOTE_CONSTANTS;
    }
    /**
     * Checks the filters selected to enable or disable the others filters
     */
    GrayoutService.prototype.checkGrayout = function () {
        var _this = this;
        var finalEnabledList;
        var tempSelectedFilters = this.quickQuoteService.getTempFiltersSelected();
        var specialFilter = this.quickQuoteService.getSpecialFilter();
        if (specialFilter) {
            finalEnabledList = specialFilter.enabled || [];
        }
        if (_.flattenDeep(tempSelectedFilters).length) {
            finalEnabledList = finalEnabledList || [];
            tempSelectedFilters.forEach(function (filterGroup, index) {
                // (has arrays as subgroups (ie: more filters)
                if (filterGroup.some(Array.isArray)) {
                    // more filters
                    filterGroup.forEach(function (moreFilterGroup) {
                        finalEnabledList = _this.getEnabledList(finalEnabledList, moreFilterGroup, true);
                    });
                }
                else {
                    // date, destination and city filters
                    finalEnabledList = _this.getEnabledList(finalEnabledList, filterGroup, false);
                }
            });
        }
        this.disableFilters(finalEnabledList);
    };
    /**
     * Retrives the enabled filter id list based on the filter group provided
     * @param finalEnabledList final enabled filters ids list
     * @param filterGroup filters group
     * @param isMoreFilters flag to know if the filter group is a more filters group
     * @returns enabled filters ids
     */
    GrayoutService.prototype.getEnabledList = function (finalEnabledList, filterGroup, isMoreFilters) {
        var _this = this;
        var mergedList = [];
        var filtersData = this.quickQuoteService.getFiltersData();
        if (isMoreFilters) {
            filterGroup.forEach(function (filter) {
                mergedList = mergedList.concat(filtersData[filter.id].enabled, _this.getFiltersByType(filter.groupType));
            });
        }
        else {
            filterGroup.forEach(function (filter) {
                mergedList = mergedList.concat(filtersData[filter.id].enabled, _this.getFiltersByType(filter.type));
            });
        }
        if (!finalEnabledList.length) {
            finalEnabledList = mergedList;
        }
        else if (mergedList.length > 0) {
            finalEnabledList = finalEnabledList.filter(function (filterId) { return mergedList.includes(filterId); });
        }
        return finalEnabledList;
    };
    /**
     * Returns the filter ids with the filter type provided
     * @param filterType Filter type
     * @returns Filters ids list
     */
    GrayoutService.prototype.getFiltersByType = function (filterType) {
        var relatedFilters = [];
        var filtersData = this.quickQuoteService.getFiltersData();
        _.forIn(filtersData, function (rawFilter) {
            if (rawFilter.type === filterType) {
                relatedFilters.push(rawFilter.id);
            }
        });
        return relatedFilters;
    };
    /**
     * Enables or disables filters from the model based on the filter ids list provided
     * @param filtersIds Filters id list
     */
    GrayoutService.prototype.disableFilters = function (filtersIds) {
        var _this = this;
        var filtersModel = this.quickQuoteService.getModel();
        filtersModel.forEach(function (filter) {
            switch (filter.type) {
                case _this.constants.filters['date'].id:
                    filter.data.forEach(function (gridConfig) {
                        gridConfig.contentData.forEach(function (gridContent) {
                            gridContent.isDisabled = !!filtersIds && !filtersIds.includes(gridContent.id);
                        });
                    });
                    break;
                case _this.constants.filters['destination'].id:
                case _this.constants.filters['privateIsland'].id:
                case _this.constants.filters['city'].id:
                    filter.data.forEach(function (imagePicker) {
                        imagePicker.disabled = !!filtersIds && !filtersIds.includes(imagePicker.id);
                    });
                    break;
                case _this.constants.filters['more-filters'].id:
                    filter.data.forEach(function (optionsGroup) {
                        optionsGroup.options.forEach(function (optionItem) {
                            optionItem.disabled = !!filtersIds && !filtersIds.includes(optionItem.id);
                        });
                    });
                    break;
            }
        });
    };
    GrayoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GrayoutService_Factory() { return new GrayoutService(i0.ɵɵinject(i1.QuickQuoteService)); }, token: GrayoutService, providedIn: "root" });
    return GrayoutService;
}());
export { GrayoutService };
